module.exports = __webpack_public_path__ + "static/media/18ECA20.b12a5ddb.jpg";